import { TextToInsert } from "./interface";
import { ContextMenuState, EditorModes, SelectedKeys } from "./types";
import { FanZoneData } from "../../../../../api/scheme";

export const initialEditorModes: EditorModes = {
  selectItem: {
    enabled: true,
    selectionEnabled: true,
  },
  insertSeatInRowOrCol: {
    enabled: false,
    selectionEnabled: false,
  },
  dotInsert: {
    enabled: false,
    selectionEnabled: false,
  },
  deleteCircle: {
    enabled: false,
    selectionEnabled: false,
  },
  textInsert: {
    enabled: false,
    selectionEnabled: false,
  },
  shapeInsert: {
    enabled: false,
    selectionEnabled: false,
  },
  fanZone: {
    enabled: false,
    selectionEnabled: false,
  },
};

export const hallPartsNames = [
  { value: "null", labelKey: "sales.null" },
  { value: "Balcony", labelKey: "sales.Balcony" },
  { value: "Right lodge", labelKey: "sales.Right lodge" },
  { value: "Left lodge", labelKey: "sales.Left lodge" },
  { value: "Lodge", labelKey: "sales.Lodge" },
  { value: "Lodge 1", labelKey: "sales.Lodge 1" },
  { value: "Lodge 2", labelKey: "sales.Lodge 2" },
  { value: "Lodge 3", labelKey: "sales.Lodge 3" },
  { value: "Parter", labelKey: "sales.Parter" },
];

export const initialTextToInsert: TextToInsert = {
  styles: {
    fontSize: 20,
  },
  properties: {
    text: "",
    type: "text",
  },
  rect: {
    x: "",
    y: "",
  },
};

export const initialSelectedKeys: SelectedKeys = {
  selectedKeyText: "",
  selectedKeyPolyline: "",
  selectedKeyRect: "",
  selectedKeyCustomCircle: "",
  selectedKeyFanZone: "",
};

export const initialContextMenu: ContextMenuState = {
  visible: false,
  x: 0,
  y: 0,
};

export const emptySelectedKeys: SelectedKeys = {
  selectedKeyText: "",
  selectedKeyPolyline: "",
  selectedKeyRect: "",
  selectedKeyCustomCircle: "",
  selectedKeyFanZone: "",
};

export const defaultZoneTranslations = {
  ro: "Fan zonă",
  ru: "Фан Зона",
  en: "Fan Zone",
};

export const defaultZone: FanZoneData = {
  name: "Fan Zone",
  max_seats: 0,
  free_seats:0,
  fixed_seats: false,
  properties: {
    rectangle: {
      rect: { x: 20, y: 20 },
      styles: {
        fill: "#f0f0f0",
        width: "100",
        height: "50",
      },
    },
    text: {
      styles: {
        fontSize: 12,
        fill: "#000",
      },
      translations: defaultZoneTranslations,
    },
  },
};
